// import config
import axios from '../config/axios';

export const getCmsList = async () => {
    try {
        const respData = await axios({
            'url': `/adminapi/cms`,
            'method': 'get'
        })
        return {
            status: "success",
            loading: false,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const SocialMediaEdit = async (data) => {
    try {
        console.log("data,data,data", data);
        const respData = await axios({
            'url': `/adminapi/SocialMedia`,
            'method': 'post',
            'data':data
        })
        return {
            status: "success",
            loading: false,
            result: respData.data
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const getSocialMedia = async () => {
    try {
        const respData = await axios({
            'url': `/adminapi/getAllSocialMedia`,
            'method': 'get'
        })
        return {
            status: "success",
            loading: false,
            result: respData.data
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const PromotionEdit = async (data) => {
    try {
        console.log("data,data,data", data);
        axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
        const respData = await axios({
            'url': `/adminapi/editPromotion`,
            'method': 'post',
            'data':data
        })
        return {
            status: "success",
            loading: false,
            result: respData.data
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const getPromotions = async () => {
    try {
        const respData = await axios({
            'url': `/adminapi/getPromotion`,
            'method': 'get'
        })
        return {
            status: "success",
            loading: false,
            result: respData.data
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false
        }
    }
}

export const updateCms = async (data) => {
    try {
    const options = {
        headers: {"content-type": "application/json"}
    }
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
        const respData = await axios({
            'url': `/adminapi/cms`,
            'method': 'put',
            'data': data,
            // 'options' : options
           
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            Errors: err.response.data.error
        }
    }
}